import { ButtonSkeleton } from '@/ui/skeleton/ButtonSkeleton.client'

export function ReferencesProductTableAddToCartSkeleton() {
  return (
    <div className="flex w-full justify-end gap-1">
      <ButtonSkeleton size="md" isRound={false} className="w-16" />
      <ButtonSkeleton
        size="md"
        isRound={{ mobile: false, tablet: false, desktop: true }}
        className="desktop:w-unset w-full"
      />
    </div>
  )
}
